import React from 'react';
import PhonicsAtoZ from './PhonicsAtoZ';
import letterDataGg from './phonics/phonics_data_gg';

function PhonicsGg() {
  return <PhonicsAtoZ letterData={letterDataGg} />;
}

export default PhonicsGg;
